import { render } from "./DownloadLogs.vue?vue&type=template&id=3f1059ff"
import script from "./DownloadLogs.vue?vue&type=script&lang=js"
export * from "./DownloadLogs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__